import React, { useEffect } from 'react';
import '../Assets/Additionalcss/Tccss.css'
import tclogo from '../Assets/Images/tc.png'
import {Link} from 'react-router-dom'
import { useLocation } from "react-router-dom";
import {FadeLoader } from 'react-spinners';

function Tcsidebar({sidebar,formopen}) {

//   function removelogalstorage(){
//     localStorage.clear()
//   }
    let roleId;
  
    useEffect(()=>{
       
        roleId=localStorage.getItem('RoleId')
        if(roleId==='02'){

            document.getElementById("TC-Adduser").style.display="none"
            document.getElementById("TC-Assign").style.display="none"
         }
    },[])

   //assigning location variable
   const location = useLocation();

   //destructuring pathname from location
   const { pathname } = location;

   //Javascript split method to get the name of the path in array
   const splitLocation = pathname.split("/");

    
  
    return (
        <div className ={sidebar ? " TC-sidebar TC-sidebar--open" : "TC-sidebar"}  id="TC-sidebar">
        <div className='TC-sidebar-title'>
            <div className='TC-sidebar-img'>
                 <img src={tclogo} alt="logo"/>&nbsp;&nbsp;
                <span> Thats&nbsp;Cool</span>
            </div>         
        </div>  
    
       <div className='TC-sidebar-menu'>
    
      {/* {role==="Teammate"?<div  className={splitLocation[1] === "Tcadduser" ? "active-tc" :'TC-sidebar-link'} >
        <i class="fa-solid fa-user-plus"></i>&nbsp; &nbsp;
            <Link to ="/Tcadduser" >Add User</Link> 
        </div> : null}  */}

        <div  className={splitLocation[1] === "Tcadduser" ? "active-tc":splitLocation[1] === "TcAddUserRole" ? "active-tc":splitLocation[1] === "TcEditPop" ? "active-tc" :'TC-sidebar-link'} id="TC-Adduser">
        <i class="fa-solid fa-user-plus"></i>&nbsp;&nbsp;
            <Link to ="/Tcadduser">Users </Link> 
        
        </div> 
        
        <div className={splitLocation[1] === "TcProfile" ? "active-tc" :'TC-sidebar-link'}>
        <i class="fa-solid fa-user"></i>&nbsp; &nbsp;&nbsp;
            <Link to ="/TcProfile">Profile</Link> 
        </div>
       
        <div className={splitLocation[1] === "Tcsection" ? "active-tc":splitLocation[1] ==="TcWinner"? 'active-tc':
        splitLocation[1] ==="TcAboutus"? 'active-tc':splitLocation[1] ==="TcTerms"? 'active-tc':
        splitLocation[1] ==="TcPrivacy"? 'active-tc':splitLocation[1] ==="TcUnfollow"? 'active-tc':
        splitLocation[1] ==="TcReport"? 'active-tc':splitLocation[1] ==="TcTransaction"? 'active-tc':
        splitLocation[1] ==="TcAddress"? 'active-tc':splitLocation[1] ==="TcContent"? 'active-tc':'TC-sidebar-link'}>
        <i class="fa-solid fa-layer-group"></i>&nbsp; &nbsp;
            <Link to ="/Tcsection">Section</Link> 
        </div>
       
        <div className={splitLocation[1] === "Tcassign" ? "active-tc" :'TC-sidebar-link'} id="TC-Assign">  
        <i class="fas fa-tasks"></i>&nbsp;&nbsp;&nbsp;&nbsp;
            <Link to ="/Tcassign">Assign</Link>   
        </div>
        
        <div className='TC-sidebar-link' id="menu">
        <i class="fa-solid fa-right-from-bracket"></i>&nbsp; &nbsp;&nbsp;
            <Link  onClick={formopen} >Logout</Link> 
        </div>


        </div>
       

        </div>
    );
}

export default Tcsidebar;